<template>
  <div>
    <!-- 禁用资格弹框 -->
    <el-dialog
      title="禁用"
      width="30%"
      custom-class="forbidden"
      :visible.sync="forbiddendialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        :model="forbiddenForm"
        :rules="rules"
        ref="forbiddenForm"
        label-width="80px"
      >
        <el-form-item label="禁用理由" prop="reason">
          <el-select
            v-model="forbiddenForm.reason"
            placeholder="请选择"
            width="100%"
          >
            <el-option
              v-for="item in disableReason"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="禁用备注" prop="remark">
          <el-input type="textarea" v-model="forbiddenForm.remark"></el-input>
        </el-form-item>
        <el-form-item class="dialog-msg" v-if="radioShow">
          该订单有续签后订单，请确认是否要一起禁用
          <el-radio-group v-model="forbiddenForm.disableExtendFlag">
            <div style="margin-top: 13px"><el-radio :label="1">是，同时禁用续签后订单</el-radio></div>
            <div style="margin-top: 5px"><el-radio :label="0">否，只禁用当前订单</el-radio></div>
          </el-radio-group>
        </el-form-item>
        <div class="forbidden-btn">
          <el-button type="info" size="medium" @click="forbiddendialog = false"
            >暂不禁用
          </el-button>
          <el-button
            class="btn-red"
            size="medium"
            :loading="btnLoading"
            @click="forbiddenConfirm('forbiddenForm')"
            >残忍禁用
          </el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 启用资格弹框 -->
    <el-dialog
      title="启用"
      :visible.sync="enabledialog"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form :model="enableForm" ref="enableForm" label-width="80px">
        <el-form-item label="启用理由">
          <el-input type="textarea" v-model="enableForm.remark"></el-input>
        </el-form-item>
        <div class="forbidden-btn">
          <el-button type="info" size="medium" @click="enabledialog = false"
            >暂不启用
          </el-button>
          <el-button
            class="btn-red"
            size="medium"
            :loading="btnLoading"
            @click="enableConfirm"
            >立即启用
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'modify-status-dialog',
  props: {
    forbiddenForm: {
      type: Object,
      default: () => {}
    },
    disableReason: {
      type: Array,
      default: () => []
    },
    btnLoading: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: () => {}
    },
    enableForm: {
      type: Object,
      default: () => {}
    },
    orderInfo: null
  },
  data () {
    return {
      forbiddendialog: false,
      enabledialog: false,
      radioShow: false
    }
  },
  created () {},
  methods: {
    forbiddenDialogShow () {
      this.forbiddendialog = true
      this.$nextTick(() => {
        this.radioShow = this.setRadioInfo()
        this.$refs.forbiddenForm.clearValidate()
      })
    },
    forbiddenDialogClose () {
      this.forbiddendialog = false
      this.forbiddenForm.reason = ''
    },

    enabledialogShow () {
      this.enabledialog = true
    },
    enabledialogClose () {
      this.enabledialog = false
    },

    forbiddenConfirm () {
      this.$emit('forbiddenConfirm', this.$refs.forbiddenForm, this.radioShow)
    },

    enableConfirm () {
      this.$emit('enableConfirm')
    },

    // 禁用启用时radio选项的显示
    setRadioInfo () {
      if (!this.orderInfo.extendPerfectApplyOrderInfo) return false

      // 关联订单的状态
      if (this.orderInfo.extendPerfectApplyOrderInfo.tradeApplyBaseVO.isStack &&
        this.orderInfo.extendPerfectApplyOrderInfo.tradeApplyInfoVO.applyStatus === '300'
      ) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.forbidden-btn {
  display: flex;
  justify-content: space-around;
}
.dialog-msg {
  color: $base-red;
  margin-left: -20px;
}
</style>
